export default __webpack_public_path__ + "static/media/igpost1.319fdba6.png";